import React, { PureComponent } from 'react'
import { isNull } from 'lodash'
import { WindowScroller, AutoSizer, List } from 'react-virtualized'
import matchMedia from 'matchmedia'
import breakpoints from '../styles/breakpoints'
import Spinner from '../common/Spinner'

const ROW_HEIGHT_DESKTOP = 150
const ROW_HEIGHT_MOBILE = 330

class ListCardVirtual extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      rowHeight: this.getRowHeight(),
    }
  }

  getRowHeight = () => {
    if (matchMedia(`screen and (max-width: ${breakpoints.xs})`).matches) {
      return ROW_HEIGHT_MOBILE
    } else {
      return ROW_HEIGHT_DESKTOP
    }
  }

  onResize = ({ height, width }) => {
    this.setState({ rowHeight: this.getRowHeight() })
  }

  renderRow = ({ key, index, isScrolling, isVisible, style }) => {
    const { items, renderListCard } = this.props
    const item = items[index]
    return (
      <div key={key} style={style}>
        {renderListCard(item, index)}
      </div>
    )
  }

  onRowsRendered = ({ stopIndex }) => {
    if (
      stopIndex > this.props.items.length - 10 &&
      !this.props.loading &&
      this.props.canLoadMoreItems
    ) {
      this.props.loadMore()
    }
  }

  render() {
    const {
      items,
      reRenderFor,
      loading,
      noRowsRenderer,
      scrollToIndex,
    } = this.props
    const reRenderProps = {
      items,
      ...reRenderFor,
    }

    return (
      <WindowScroller>
        {({ height, isScrolling, onChildScroll, scrollTop }) => (
          <AutoSizer disableHeight onResize={this.onResize}>
            {({ width }) => (
              <div>
                <div style={{ width: width }}>
                  {loading && isNull(items) && <Spinner centered />}
                </div>
                <List
                  style={{ outline: 'none' }}
                  {...reRenderProps}
                  scrollToIndex={scrollToIndex}
                  autoHeight={true}
                  height={height}
                  width={width}
                  isScrolling={isScrolling}
                  onScroll={onChildScroll}
                  scrollTop={scrollTop}
                  rowCount={isNull(items) ? 0 : items.length}
                  rowHeight={this.state.rowHeight}
                  onRowsRendered={this.onRowsRendered}
                  rowRenderer={this.renderRow}
                  noRowsRenderer={noRowsRenderer}
                />
                <div style={{ width: width }}>
                  {loading &&
                    !isNull(items) &&
                    items.length > 0 &&
                    <Spinner centered />}
                </div>
              </div>
            )}
          </AutoSizer>
        )}
      </WindowScroller>
    )
  }
}

export default ListCardVirtual



// WEBPACK FOOTER //
// ./src/common/ListCardVirtual.js